import { render, staticRenderFns } from "./SpaymentreceiptsPdview.vue?vue&type=template&id=868f79a2&scoped=true"
import script from "./SpaymentreceiptsPdview.vue?vue&type=script&lang=js"
export * from "./SpaymentreceiptsPdview.vue?vue&type=script&lang=js"
import style0 from "./SpaymentreceiptsPdview.vue?vue&type=style&index=0&id=868f79a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868f79a2",
  null
  
)

export default component.exports